/*
  SiwakStick scratch-popup behaviour (4-stage with phone capture).

  Stage 1: scratch ~45% to reveal Stage 2
  Stage 2: email gate , subscribes email to EMAIL list (SZDLYs) via the
           LEGACY endpoint manage.kmail-lists.com (proven CORS-clean).
           Advances to Stage 3 immediately, fire-and-forget.
  Stage 3: phone gate , fires THREE subscribe paths in parallel to
           capture the phone reliably (see "Why three paths" below).
           Skip link advances directly to Stage 4 if user doesn't want
           to give phone. Either way SETS the claimed flag.
  Stage 4: SIWAK10 code card + Copy + Shop & Save 10%.

  Why three subscribe paths for phone:
    The simple legacy endpoint that captures emails doesn't accept phone.
    Klaviyo's modern client API requires a 'revision' HTTP header that
    triggers a CORS preflight, and Klaviyo's preflight refuses POST.
    To get phones into Klaviyo we layer:
      (a) LEGACY endpoint with EMAIL going to SMS list (W47KJb)
          - Cleanest reliability. Gets the profile into W47KJb at least,
            email field populated.
      (b) klaviyo.js onsite SDK identify()
          - Klaviyo's recommended client-side path. Loads their SDK,
            identifies the profile with email + phone + SMS consent.
            Phone lands as a profile attribute regardless of list state.
      (c) no-cors POST to /client/subscriptions/ with SMS consent
          - The browser sends the body without preflight. Klaviyo may
            still process it. We can't read the response (opaque).

    Whichever one lands, the phone is captured. Code reveal in Stage 4
    fires instantly , never delays the user.
*/

(function () {
  'use strict';

  /* ---------- storage helpers (cookie + localStorage) ---------- */
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : null;
  }
  function lsGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }

  function isClaimed() {
    return !!(lsGet('siwak_popup_claimed') || getCookie('siwak_popup_claimed'));
  }
  function isDismissed() {
    return !!(lsGet('siwak_popup_dismissed') || getCookie('siwak_popup_dismissed'));
  }
  function setClaim() { lsSet('siwak_popup_claimed', '1'); setCookie('siwak_popup_claimed', '1', 90); }
  /* Dismiss now matches claim duration (90 days, was 1 day). Once a
     visitor closes the popup they're done , no pill, no popup re-show
     for 90 days. Old 1-day behavior re-popped the popup the next visit
     which read as nagging, and the pill in the corner read the same. */
  function setDismiss() { lsSet('siwak_popup_dismissed', '1'); setCookie('siwak_popup_dismissed', '1', 90); }
  /* Treat either flag as "user is done with the popup" for the purpose
     of suppressing the pill + the auto-show. Used by maybeShow() and
     ensurePillHiddenIfClaimed() below. */
  function isDoneWithPopup() { return isClaimed() || isDismissed(); }

  /* ---------- email validation ---------- */
  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());
  }

  /* ---------- popup root + DOM refs ---------- */
  var popup = document.querySelector('[data-hematite-scratch]');
  if (!popup) return;

  var pill = document.querySelector('[data-hematite-scratch-pill]');
  var steps = popup.querySelectorAll('[data-scratch-step]');
  var closeBtn = popup.querySelector('[data-scratch-close]');

  var KLAVIYO_PUBLIC_KEY = popup.getAttribute('data-klaviyo-public-key') || '';
  var KLAVIYO_EMAIL_LIST = popup.getAttribute('data-klaviyo-email-list-id') || '';
  var KLAVIYO_SMS_LIST = popup.getAttribute('data-klaviyo-sms-list-id') || '';
  var KLAVIYO_SOURCE = popup.getAttribute('data-klaviyo-source') || 'hematite-scratch-popup';
  var DISCOUNT_CODE = popup.getAttribute('data-discount-code') || 'IRON10';

  /* ---------- klaviyo.js onsite SDK loader (lazy)
     Inserts the SDK <script> tag once, the first time we need it (i.e.
     when the user reaches Stage 3 phone capture). klaviyo.js queues
     pushes into window.klaviyo before it loads, so the identify() call
     can be made immediately. */
  var klaviyoSdkLoading = false;
  function ensureKlaviyoSdk() {
    if (!KLAVIYO_PUBLIC_KEY || klaviyoSdkLoading) return;
    if (window._klaviyoLoaded) return;
    if (document.querySelector('script[data-klaviyo-sdk]')) {
      window._klaviyoLoaded = true;
      return;
    }
    klaviyoSdkLoading = true;
    var s = document.createElement('script');
    s.async = true;
    s.setAttribute('data-klaviyo-sdk', '1');
    s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(KLAVIYO_PUBLIC_KEY);
    s.onload = function () { window._klaviyoLoaded = true; console.log('[hematite-scratch] klaviyo.js loaded'); };
    s.onerror = function () { console.warn('[hematite-scratch] klaviyo.js failed to load'); };
    document.head.appendChild(s);
  }

  /* ---------- (a) LEGACY endpoint subscribe ----------
     Form-encoded POST, no custom headers, no CORS preflight. Used for
     BOTH Stage 2 (email -> SZDLYs) and Stage 3's first path (email ->
     W47KJb). Klaviyo accepts a public list ID directly. */
  var KLAVIYO_LEGACY_URL = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

  function subscribeLegacy(email, listId, source) {
    var clean = String(email || '').trim();
    if (!isValidEmail(clean)) { console.warn('[hematite-scratch] legacy: invalid email', email); return; }
    if (!listId || listId === 'REPLACE_ME') { console.log('[hematite-scratch] legacy: no list id', source); return; }
    console.log('[hematite-scratch] legacy subscribe:', clean, '->', listId, 'src=' + source);

    var params = new URLSearchParams();
    params.set('g', listId);
    params.set('email', clean);
    if (source) params.set('$source', source);

    try {
      fetch(KLAVIYO_LEGACY_URL, { method: 'POST', body: params, keepalive: true })
        .then(function (res) { return res.json().catch(function () { return null; }); })
        .then(function (data) {
          if (data) console.log('[hematite-scratch] legacy response (' + listId + '):', data);
        })
        .catch(function (err) { console.warn('[hematite-scratch] legacy failed:', err); });
    } catch (err) {
      console.warn('[hematite-scratch] legacy threw:', err);
    }
  }

  /* ---------- (b) klaviyo.js identify ---------- */
  function klaviyoIdentify(email, phone) {
    if (!KLAVIYO_PUBLIC_KEY) return;
    ensureKlaviyoSdk();
    window.klaviyo = window.klaviyo || [];
    var attrs = {};
    if (email) attrs.$email = email;
    if (phone) attrs.$phone_number = phone;
    if (Object.keys(attrs).length === 0) return;
    console.log('[hematite-scratch] klaviyo.identify:', attrs);
    try {
      window.klaviyo.push(['identify', attrs]);
    } catch (err) {
      console.warn('[hematite-scratch] klaviyo.identify threw:', err);
    }
  }

  /* ---------- (c) no-cors POST to /client/subscriptions/ ----------
     Fire-and-forget. We CAN'T read the response (mode: 'no-cors' makes
     the response opaque) but the body still goes to Klaviyo's servers.
     If their endpoint accepts requests without the 'revision' header it
     processes; if not, paths (a) + (b) still capture the phone. */
  function subscribeNoCors(email, phone, listId) {
    if (!KLAVIYO_PUBLIC_KEY || !listId || listId === 'REPLACE_ME') return;
    var now = new Date().toISOString();
    var subscriptions = {};
    if (phone) subscriptions.sms = { marketing: { consent: 'SUBSCRIBED', consented_at: now } };
    if (email) subscriptions.email = { marketing: { consent: 'SUBSCRIBED', consented_at: now } };
    var attrs = { subscriptions: subscriptions };
    if (email) attrs.email = email;
    if (phone) attrs.phone_number = phone;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: KLAVIYO_SOURCE,
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_PUBLIC_KEY);
    console.log('[hematite-scratch] no-cors POST ->', listId);
    try {
      fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify(body),
        keepalive: true
        /* deliberately NO Content-Type header , browser defaults to
           text/plain which avoids CORS preflight */
      }).catch(function (err) { console.warn('[hematite-scratch] no-cors fetch caught:', err); });
    } catch (err) {
      console.warn('[hematite-scratch] no-cors threw:', err);
    }
  }

  /* ---------- belt-and-braces pill hide ----------
     Any prior interaction with the popup (claim OR dismiss) means the
     visitor has seen the 10% offer and made their call. The corner
     pill is gone for them, period. */
  function ensurePillHiddenIfDone() {
    if (pill && isDoneWithPopup()) pill.setAttribute('hidden', '');
  }
  ensurePillHiddenIfDone();

  /* ---------- show/hide + step transitions ---------- */
  function showPopup() {
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (pill) pill.setAttribute('hidden', '');
  }
  function hidePopup() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    /* Either flag suppresses the pill. If the visitor closes the popup
       without claiming, we mark them dismissed (90-day flag) , no pill
       and no auto re-popup for 90 days. */
    if (!isDoneWithPopup()) setDismiss();
    if (pill) pill.setAttribute('hidden', '');
  }
  function goToStep(n) {
    steps.forEach(function (s) {
      var idx = parseInt(s.getAttribute('data-scratch-step'), 10);
      s.classList.toggle('is-active', idx === n);
    });
  }

  /* ---------- scratch canvas ---------- */
  var canvas = popup.querySelector('[data-scratch-canvas]');
  var ctx, scratchInitialized = false;
  var SCRATCH_THRESHOLD = 0.45;

  function initScratch() {
    if (scratchInitialized || !canvas) return;
    scratchInitialized = true;
    var rect = canvas.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    canvas.width = rect.width * dpr; canvas.height = rect.height * dpr;
    ctx = canvas.getContext('2d'); ctx.scale(dpr, dpr);
    var grad = ctx.createLinearGradient(0, 0, rect.width, rect.height);
    grad.addColorStop(0, '#B8860B'); grad.addColorStop(0.35, '#FFD700');
    grad.addColorStop(0.5, '#FFF1A8'); grad.addColorStop(0.65, '#FFD700');
    grad.addColorStop(1, '#B8860B');
    ctx.fillStyle = grad; ctx.fillRect(0, 0, rect.width, rect.height);
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.16)'; ctx.lineWidth = 1;
    for (var x = -rect.height; x < rect.width; x += 8) {
      ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x + rect.height, rect.height); ctx.stroke();
    }
    ctx.fillStyle = 'rgba(40, 24, 0, 0.55)';
    ctx.font = '800 22px Inter, system-ui, sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText('SCRATCH HERE', rect.width / 2, rect.height / 2);
    ctx.globalCompositeOperation = 'destination-out';

    var isDown = false;
    function pos(e) { var r = canvas.getBoundingClientRect(); var t = (e.touches && e.touches[0]) || e; return { x: t.clientX - r.left, y: t.clientY - r.top }; }
    function dot(p) { ctx.beginPath(); ctx.arc(p.x, p.y, 28, 0, Math.PI * 2); ctx.fill(); }
    function line(p1, p2) { ctx.lineWidth = 56; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(p1.x, p1.y); ctx.lineTo(p2.x, p2.y); ctx.stroke(); ctx.strokeStyle = '#000'; }
    var last = null;
    function down(e) { e.preventDefault(); isDown = true; last = pos(e); dot(last); }
    function move(e) { if (!isDown) return; e.preventDefault(); var p = pos(e); line(last, p); dot(p); last = p; checkScratched(); }
    function up()    { isDown = false; last = null; }
    canvas.addEventListener('mousedown', down); canvas.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    canvas.addEventListener('touchstart', down, { passive: false });
    canvas.addEventListener('touchmove', move, { passive: false });
    canvas.addEventListener('touchend', up);
    var advancing = false;
    function checkScratched() {
      if (advancing) return;
      var img = ctx.getImageData(0, 0, canvas.width, canvas.height);
      var data = img.data, cleared = 0, sampled = 0, total = data.length / 4, stride = 50;
      for (var i = 0; i < total; i += stride) { if (data[i * 4 + 3] === 0) cleared++; sampled++; }
      if (cleared / sampled >= SCRATCH_THRESHOLD) {
        advancing = true;
        /* Scratching is itself a hard commitment , the user dragged
           their finger across the prize, they don't need to be asked
           about the discount on every subsequent visit. Marking claimed
           here means closing the popup at the email or phone stage
           still leaves them in the claimed state, no pill ever returns.
           Pill that may be visible from an earlier dismissed session is
           hidden immediately. */
        markClaimed();
        canvas.style.transition = 'opacity 360ms ease';
        canvas.style.opacity = '0';
        setTimeout(function () { goToStep(2); }, 380);
      }
    }
  }

  /* ---------- Stage 2: email gate
     Email -> SZDLYs (legacy endpoint, proven). Advances to phone (Stage 3). */
  var emailForm = popup.querySelector('[data-scratch-email-form]');
  var emailInput = popup.querySelector('[data-scratch-email-input]');
  var emailErr = popup.querySelector('[data-scratch-email-error]');
  var emailSubmit = popup.querySelector('[data-scratch-email-submit]');

  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = (emailInput.value || '').trim();
      if (!isValidEmail(v)) { emailErr.hidden = false; emailInput.focus(); return; }
      emailErr.hidden = true;
      emailSubmit.disabled = true; emailSubmit.textContent = 'REVEALING…';

      /* Legacy endpoint to email list */
      subscribeLegacy(v, KLAVIYO_EMAIL_LIST, KLAVIYO_SOURCE);
      /* Pre-load klaviyo SDK so it's ready by the time Stage 3 fires */
      ensureKlaviyoSdk();

      /* Email handover counts as claimed. Without this, a user who enters
         an email then closes the popup at the phone-capture step (Stage 3)
         would hit hidePopup() with isClaimed()=false, fire setDismiss(),
         and see the pill again on next visit even though they've already
         given us their email and received the discount code via Klaviyo. */
      markClaimed();

      setTimeout(function () {
        emailSubmit.disabled = false;
        emailSubmit.textContent = 'REVEAL MY CODE';
      }, 600);
      goToStep(3);
    });
  }

  /* ---------- Stage 3: phone capture
     Three subscribe paths fire in parallel:
       (a) legacy email -> W47KJb (gets the profile into the SMS list at
           minimum, even though only email field populates)
       (b) klaviyo.js identify (email + phone + SMS consent on profile)
       (c) no-cors POST to /client/subscriptions/ with SMS consent
     All fire-and-forget. Stage 4 shows instantly. */
  var phoneForm = popup.querySelector('[data-scratch-phone-form]');
  var phoneInput = popup.querySelector('[data-scratch-phone-input]');
  var phoneErr = popup.querySelector('[data-scratch-phone-error]');
  var phoneSubmit = popup.querySelector('[data-scratch-phone-submit]');
  var skipPhone = popup.querySelector('[data-scratch-skip-phone]');

  function markClaimed() {
    setClaim();
    if (pill) pill.setAttribute('hidden', '');
  }

  function normalizePhone(v) {
    v = (v || '').trim();
    if (!v) return '';
    var digits = v.replace(/\D/g, '');
    if (/^\+/.test(v)) return '+' + digits;
    /* Australian mobile: 04XX XXX XXX (10 digits starting with 0) */
    if (/^0\d{9}$/.test(digits)) return '+61' + digits.slice(1);
    return '+' + digits;
  }

  if (phoneForm) {
    phoneForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var raw = (phoneInput.value || '').trim();
      var digits = raw.replace(/\D/g, '');
      if (digits.length < 7) { phoneErr.hidden = false; phoneInput.focus(); return; }
      phoneErr.hidden = true;
      phoneSubmit.disabled = true; phoneSubmit.textContent = 'UNLOCKING…';

      var phone = normalizePhone(raw);
      var email = (emailInput && emailInput.value || '').trim() || null;

      /* (a) email -> SMS list via legacy endpoint */
      if (email) subscribeLegacy(email, KLAVIYO_SMS_LIST, KLAVIYO_SOURCE + '-phone-step');
      /* (b) klaviyo.js identify with email + phone */
      klaviyoIdentify(email, phone);
      /* (c) no-cors POST to new client API with SMS subscription consent */
      subscribeNoCors(email, phone, KLAVIYO_SMS_LIST);

      markClaimed();
      goToStep(4);

      setTimeout(function () {
        phoneSubmit.disabled = false;
        phoneSubmit.textContent = 'UNLOCK MY 10% OFF CODE';
      }, 600);
    });
  }

  if (skipPhone) {
    skipPhone.addEventListener('click', function () {
      markClaimed();
      goToStep(4);
    });
  }

  /* ---------- Stage 4: copy code + shop now ---------- */
  var copyBtn = popup.querySelector('[data-scratch-copy]');
  var copyLabel = popup.querySelector('[data-scratch-copy-label]');
  var codeValue = popup.querySelector('[data-scratch-code-value]');
  var shopNowBtn = popup.querySelector('[data-scratch-shop-now]');

  if (copyBtn && codeValue) {
    copyBtn.addEventListener('click', function () {
      var code = (codeValue.textContent || DISCOUNT_CODE).trim();
      var done = function () {
        copyBtn.classList.add('is-copied');
        if (copyLabel) copyLabel.textContent = 'COPIED!';
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (copyLabel) copyLabel.textContent = 'COPY CODE';
        }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {
          var range = document.createRange(); range.selectNode(codeValue);
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(range);
          try { document.execCommand('copy'); done(); } catch (e) {}
          sel.removeAllRanges();
        });
      } else { done(); }
    });
  }

  if (shopNowBtn) {
    shopNowBtn.addEventListener('click', function () {
      window.location.href = '/discount/' + encodeURIComponent(DISCOUNT_CODE) + '?redirect=/';
    });
  }

  /* ---------- close + pill ---------- */
  if (closeBtn) closeBtn.addEventListener('click', function () { hidePopup(); });
  if (pill) {
    pill.addEventListener('click', function (e) {
      /* X on the pill = "I don't want to see this anymore". Treat as
         claimed so the pill never returns. Without stopping propagation
         here the pill's own click handler would re-open the popup. */
      if (e.target.closest('.hematite-scratch-pill__close')) {
        e.stopPropagation();
        setClaim();
        pill.setAttribute('hidden', '');
        return;
      }
      showPopup();
      initScratch();
    });
  }

  /* ---------- first-visit auto-show ----------
     Either flag (claimed or dismissed) means the visitor has already
     made their call on the offer. No popup auto-show, no pill. The
     popup re-opens only if they click the pill on a fresh-state visit. */
  function maybeShow() {
    if (isDoneWithPopup()) {
      if (pill) pill.setAttribute('hidden', '');
      return;
    }
    setTimeout(function () { showPopup(); initScratch(); }, 800);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    maybeShow();
  } else {
    document.addEventListener('DOMContentLoaded', maybeShow);
  }
})();
